// 用户管理
import { Request } from '@/http/request'

// 用户菜单页
export function getWebLogs(parameter: any) {
  return Request.axiosInstance.post('/web/log/list',parameter)
}

export default { getWebLogs }